import errorHandler from "common/errorHandler";
import { call, delay, put, race, take } from "redux-saga/effects";
import { Endpoints } from "services/api";
import * as actions from "./actions";

const HEARTBEAT_INTERVAL = 30000; // 30 seconds

function* sendHeartbeat(api) {
    try {
        yield call([api, api.put], `${Endpoints.users}/api/v1/users/recent/heartbeat`, {});
        yield put(actions.heartbeatSuccess());
    } catch (error) {
        let errorObject = errorHandler(error, "Send", "heartbeat");
        yield put(actions.heartbeatFailure(errorObject));
    }
}

function* heartbeatLoop(api) {
    while (true) {
        yield call(sendHeartbeat, api);
        yield delay(HEARTBEAT_INTERVAL);
    }
}

function* watchHeartbeatStart(api) {
    while (true) {
        yield take(actions.HEARTBEAT_START);
        yield race({
            loop: call(heartbeatLoop, api),
            stop: take(actions.HEARTBEAT_STOP),
        });
    }
}

export default function* ({ api }) {
    yield call(watchHeartbeatStart, api);
}
